export const CUSTOM_VIEW_TASKS_TABLE_CONFIG = {
    name            : 'Tasks table',
    icon            : 'i5-table',
}
